var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuxText01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 30,
    viewBox: "0 0 202 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700783 29V0.71875H6.56016V24.1562H18.7477V29H0.700783ZM38.4367 0.71875H44.3352V19.0781C44.3352 25.2695 39.6281 29.4102 32.6164 29.3906C25.5852 29.4102 20.9367 25.2695 20.9367 19.0781V0.71875H26.7961V18.6094C26.8156 21.8711 29.1203 24.2148 32.6164 24.2344C36.1516 24.2148 38.4563 21.8711 38.4367 18.6094V0.71875ZM52.9305 0.71875L58.7117 10.4453H58.907L64.7273 0.71875H71.368L62.7352 14.8594L71.5633 29H64.7664L58.907 19.2734H58.7117L52.8523 29H46.0945L54.9617 14.8594L46.2508 0.71875H52.9305ZM96.293 8.80469C96.0586 6.55859 94.2812 5.25 91.4102 5.25C88.4414 5.25 86.7812 6.61719 86.7617 8.49219C86.7422 10.543 88.8516 11.4609 91.293 12.0078L93.832 12.6328C98.6758 13.7461 102.289 16.207 102.309 20.9141C102.289 26.0898 98.2656 29.4102 91.3711 29.3906C84.5352 29.4102 80.1797 26.2461 80.0039 20.1719H85.707C85.9023 23.0234 88.168 24.4688 91.293 24.4688C94.3789 24.4688 96.3711 23.0234 96.3711 20.9141C96.3711 18.9805 94.6133 18.082 91.5273 17.3203L88.4414 16.5781C83.6758 15.4062 80.7461 13.0234 80.7461 8.88281C80.7266 3.74609 85.2578 0.328125 91.4492 0.328125C97.7188 0.328125 101.84 3.80469 101.918 8.80469H96.293ZM104.537 29V0.71875H110.396V12.4375H122.662V0.71875H128.56V29H122.662V17.2812H110.396V29H104.537ZM136.452 29H130.124L139.929 0.71875H147.468L157.234 29H150.945L148.816 22.4766H138.581L136.452 29ZM140.066 17.9062H147.331L143.796 7.08594H143.601L140.066 17.9062ZM158.837 29V0.71875H169.93C176.356 0.71875 180.048 4.33203 180.048 9.9375C180.048 13.8047 178.27 16.6172 175.048 18.0039L181.063 29H174.579L169.169 18.9609H164.696V29H158.837ZM164.696 14.1953H168.837C172.313 14.1953 174.013 12.7695 173.993 9.9375C174.013 7.08594 172.313 5.54297 168.837 5.52344H164.696V14.1953ZM182.51 29V0.71875H201.495V5.5625H188.37V12.4375H200.518V17.2812H188.37V24.1562H201.534V29H182.51Z",
    fill: "url(#paint0_linear_531_12644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_12644",
    x1: 101,
    y1: 29.069,
    x2: 101,
    y2: 1.62045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#EBB35F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#E3AC59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A9844D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB662"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxText01);
export default __webpack_public_path__ + "static/media/lux_text01.2c072da81af8e7f6246f490f63c90259.svg";
export { ForwardRef as ReactComponent };